export default (num) => +(`${Math.round(`${num}e+1`)}e-1`);// eslint-disable-line i18next/no-literal-string
